import Clipboard from "clipboard";
const { __, _x, _n, _nx } = wp.i18n;

function initCopyClipboard (){
    let clipboard = new Clipboard('.clipboard-btn');


    clipboard.on('success', function (e) {
        let html = document.createElement('div');
        html.classList.add('clipboard-modal', 'success');
        // html.innerHTML = '<p>Die E-Mail-Adresse ' + e.text + ' wurde erfolgreich in die Zwischenablage kopiert!</p>';
        html.innerHTML =  '<p>'+ __('E-Mail-Adresse erfolgreich in die Zwischenablage kopiert!', 'ume-starter') + '</p>';


        document.body.appendChild(html);

        jQuery(html).fadeIn();

        setTimeout(() => {
            jQuery(html).fadeOut();
        }, 4000);

        setTimeout(() => {
            html.remove();
        }, 6000);

        e.clearSelection();


    });

    clipboard.on('error', function (e) {
        let html = document.createElement('div');
        html.classList.add('clipboard-modal', 'error');
        html.innerHTML = '<p>'+ __('Die E-Mail-Adresse konnte nicht in die Zwischenablage kopiert werden!', 'ume-starter') + '</p>';

        jQuery(html).fadeIn();
        setTimeout(() => {
            jQuery(html).fadeOut();
        }, 4000);

        setTimeout(() => {
            html.remove();
        }, 6000);
    });
}

initCopyClipboard();